module.exports = __webpack_public_path__ + "static/html-387273e516903c231d3cd0272cfd9f22.png";